import styled from 'styled-components';
import { Box } from '../Box/Box';
import { Text } from '../Text/Text';
const getMaxWidth = em => parseInt(em) - 0.01;
const breakpoints = props => ({
  xs: `@media screen and (max-width: ${getMaxWidth(props.theme.breakpoints[0])}em)`,
  sm: `@media screen and (min-width: ${props.theme.breakpoints[0]}) and (max-width: ${getMaxWidth(props.theme.breakpoints[1])}em)`,
  md: `@media screen and (min-width: ${props.theme.breakpoints[1]}) and (max-width: ${getMaxWidth(props.theme.breakpoints[2])}em)`,
  lg: `@media screen and (min-width: ${props.theme.breakpoints[2]}) and (max-width: ${getMaxWidth(props.theme.breakpoints[3])}em)`,
  xl: `@media screen and (min-width: ${props.theme.breakpoints[3]}) and (max-width: ${getMaxWidth(props.theme.breakpoints[4])}em)`,
  xxl: `@media screen and (min-width: ${props.theme.breakpoints[4]})`,
  print: `@media print`
});
const hidden = key => props => props[key] ? {
  [breakpoints(props)[key]]: {
    display: 'none'
  }
} : null;
/**
 * @public
 */
export const Hide = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Hide",
  componentId: "sc-i482tf-0"
})(["", " ", " ", " ", " ", " ", " ", ";"], hidden('xs'), hidden('sm'), hidden('md'), hidden('lg'), hidden('xl'), hidden('xxl'), hidden('print'));
Hide.displayName = 'Hide';
Hide.text = styled(Text).withConfig({
  displayName: "Hide__text",
  componentId: "sc-i482tf-1"
})(["display:inline;", " ", " ", " ", " ", " ", " ", ";"], hidden('xs'), hidden('sm'), hidden('md'), hidden('lg'), hidden('xl'), hidden('xxl'), hidden('print'));